export default __webpack_public_path__ + "static/media/truck-icon.23a2bcd1.svg";